import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";
import { BASE_URL } from "../../../request";
import SortDirection from "react-virtualized/dist/commonjs/Table/SortDirection";
import { PARTNER_ROLE } from "../../../Common/constants";
import React from "react";

const ModuleDefinition = {
  name: "Partners",
  entityName: "partners",
  filterFields: ["name", "ticker", "address", "email", "role", "region", "margin", "description"],
  restConfig: {
    baseURL: `${BASE_URL}`,
    dataField: "content",
    create: {
      url: () => "api/partners",
      method: "post",
    },
    fetch: {
      url: ({ id }) =>
        `api/partners${id ? "/" + id : "?size=10000"}`,
      method: "get",
    },
    update: {
      url: ({ id }) => `api/partners/${id}`,
      method: "put",
    },
    delete: {
      url: ({ id }) => `api/partners/${id}`,
      method: "delete",
    },
  },
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "translations",
  },
  allowClone: false,
  allowDelete: false,
  allowExport: true,
  exportFileName: "crm_partners_export",
  sorting: {
    property: "numActiveProperties",
    sortable: true,
    sortDirection: SortDirection.DESC,
  },
  reorder: false,
  showTotalRecords: true,
  fields: {
    list: [
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "numActiveProperties",
        displayName: "#Prop.Act.",
        width: 100,
      },
      {
        fieldName: "name",
        displayName: "Nombre",
        width: 200,
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        width: 100,
      },
      {
        fieldName: "address",
        displayName: "Dirección",
        width: 200,
      },
      {
        fieldName: "email",
        displayName: "Email",
        width: 200,
      },
      {
        fieldName: "role",
        displayName: "Role",
        width: 100,
      },
      {
        fieldName: "region",
        displayName: "Región",
        width: 160,
      },
      {
        fieldName: "margin",
        displayName: "Margen",
        width: 80,
      },
      {
        fieldName: "description",
        displayName: "Notas",
        width: 400,
      },
    ],
    form: [
      {
        fieldName: "name",
        displayName: "Nombre",
        widget: "input",
        required: true,
        order: 10,
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        widget: "input",
        required: true,
        readOnly: true,
        order: 20,
      },
      {
        fieldName: "address",
        displayName: "Dirección",
        widget: "input",
        order: 30,
      },
      {
        fieldName: "email",
        displayName: "Email",
        widget: "input",
        order: 40,
      },
      {
        fieldName: "role",
        displayName: "Role",
        widget: "selector",
        defaultValue: "Partner",
        optionDisplay: {
          [PARTNER_ROLE.DIRECT]: {
            label: "Direct",
          },
          [PARTNER_ROLE.PARTNER]: {
            label: "Partner",
          },
          [PARTNER_ROLE.PRESCRIPTOR]: {
            label: "Prescriptor",
          },
        },
        order: 50,
      },
      {
        fieldName: "region",
        displayName: "Región",
        widget: "input",
        order: 60,
      },
      {
        fieldName: "margin",
        displayName: "Margen %",
        widget: "input",
        order: 70,
      },
      {
        fieldName: "description",
        displayName: "Notas",
        widget: "input",
        order: 80,
      },
    ],
  },
  validation: {
    name: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    ticker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    email: {
      constraints: {
        emailList: {},
      },
    },
    margin: {
      type: "Number",
      constraints: {
        numericality: {
          greaterThanOrEqualTo: 0,
          lessThanOrEqualTo: 100,
          message: <div>El valor debe estar entre 0 y 100</div>,
        },
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
